import { defineNuxtRouteMiddleware } from '#app/composables/router';
import { useChangingLayout } from '~/stores/loading';

export default defineNuxtRouteMiddleware((to, from) => {
	const changingLayout = useChangingLayout();
	changingLayout.value = to.meta.layout !== from.meta.layout;
});
